import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { fadeAnimation } from 'src/animations';
import { ContractService } from '../../../services/contract.service';

@Component({
  selector: 'app-select-contract-type',
  templateUrl: './select-contract-type.component.html',
  styleUrls: ['./select-contract-type.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectContractTypeComponent),
      multi: true
    }
  ],
  animations: [ fadeAnimation ]
})
export class SelectContractTypeComponent implements ControlValueAccessor, OnDestroy, OnInit {

  @Input() appearance: 'standard' | 'fill' | 'outline' = 'fill';

  contractTypes$ = this._contractService.loadAllContractTypes(true);

  valueControl: FormControl = new FormControl();

  private _subscriptions: Subscription[] = [];

  constructor(private _contractService: ContractService) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
  }

  public onTouched: () => void = () => { };
  registerOnTouched = (fn: any) => this.onTouched = fn;

  registerOnChange(fn: any): void {
    this._subscriptions.push(this.valueControl.valueChanges.subscribe(fn));
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.valueControl.disable() : this.valueControl.enable();
  }

  writeValue = (val: any) => this.valueControl.patchValue(val);

}
